var scope_0 = require('/vercel/path0/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/92b415b5f4cab4f21acc9fefc87a32c4.js').default;export default
        Object.assign({}, scope_0 )
    